import script from "./formDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./formDialog.vue?vue&type=script&setup=true&lang=js"

import "./formDialog.vue?vue&type=style&index=0&id=61a0bb16&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境总后台manage.jsyinba.com/jsgeneral/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61a0bb16"]])

export default __exports__